import { useCallback, useState } from 'react';

const RecognisedReferences = ({ recRef, setRecRef, addReference }) => {
    const [refList, setRefList] = useState(() => {
        let temp = [];
        recRef.forEach((rcRef) => {
            if (temp[temp.length - 1] !== rcRef.reference) {
                temp.push(rcRef.reference);
            }
        });
        return temp;
    });

    const chooseRecRef = useCallback((ref) => {
        setRefList((prevVal) => prevVal.filter((x) => x !== ref.reference));
        setRecRef((prevVal) => prevVal.filter((x) => x.reference !== ref.reference));
        addReference(ref);
    }, [addReference, setRecRef]);

    const removeRecRef = useCallback((ref) => {
        setRefList(prevVal => prevVal.filter(x => x !== ref))
        setRecRef(prevVal => prevVal.filter(x => x.reference !== ref))
    }, [setRecRef]);

    return (
        <div style={{minWidth : '300px'}} className='position-relative p-3'>
            {refList.map((ref, idx) => (
                <div key={`reflist-${ref}`}>
                    <p className='mb-1'>
                        Bitte eine Kategorie von Referenznummer {ref} auswählen
                    </p>
                    {recRef.map((rcRef) => (
                        <button
                            key={`recref-${rcRef._id}`}
                            data-test={`recref-${idx}-${rcRef.category}`}
                            className='btn btn-outline-warning my-1 mr-1'
                            onClick={() => chooseRecRef(rcRef)}
                        >
                            {rcRef.category}
                        </button>
                    ))}
                    <button
                        data-test='recref-rm-btn'
                        className='btn btn-outline-danger my-1 mr-1'
                        onClick={() => removeRecRef(ref)}
                    >
                        Referenznummer löschen
                    </button>
                </div>
            ))}
        </div>
    );
};

export default RecognisedReferences;
